import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, isNil } from 'ramda';
import { fetchClassHighScoreReportRequest } from 'stores/report/actions';
import cloneDeep from 'lodash.clonedeep';
import NoReport from 'components/Report/NoReport';
import StudentTable from 'components/Report/StudentTableReport';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { LoadingContainer } from './ReportPage.styles';
import Spinner from 'components/Shared/Spinner';

const HighScoreReportByStudent = ({ visible }) => {
  const dispatch = useDispatch();
  // Redux States
  const {
    classHighScoreReport,
    selectedClass,
    reportLevel,
    selectedSyllabus,
    isLoading: reportsLoading
  } = useSelector(state => state.reports);
  const [sortDetail, setSortDetail] = useState(null);
  const isLeveless = isEmpty(selectedSyllabus.Levels);

  const sortedData = useCallback(() => {
    if (sortDetail) {
      const { type, sortType } = sortDetail;
      const hasData = classHighScoreReport.some(
        datum => datum.MasteryLevels[type] > 0
      );
      if (hasData) {
        const result = cloneDeep(classHighScoreReport).sort((a, b) => {
          const c = a.MasteryLevels[type] - b.MasteryLevels[type] > 0 ? 1 : -1;
          return sortType === 'asc' ? c : c * -1;
        });
        return result;
      }
      return classHighScoreReport;
    }
    return classHighScoreReport;
  }, [classHighScoreReport, sortDetail]);

  useDeepCompareEffect(() => {
    if (selectedClass && selectedSyllabus && !isNil(reportLevel)) {
      dispatch(
        fetchClassHighScoreReportRequest({
          classID: selectedClass.ID,
          reportLevel: isLeveless ? -1 : reportLevel.ID,
          curriculumID: selectedSyllabus.CurriculumID
        })
      );
    }
  }, [dispatch, reportLevel, selectedClass, selectedSyllabus]);
  const handleSortClick = ({ type, sortType }) => {
    setSortDetail(prev => {
      if (prev) {
        return prev.type === type && prev.sortType === sortType
          ? null
          : { type, sortType };
      }
      return { type, sortType };
    });
  };
  const renderResult = () => {
    if (reportsLoading) {
      return (
        <LoadingContainer>
          <Spinner styles={{ marginTop: '0' }} />
        </LoadingContainer>
      );
    }
    if (classHighScoreReport?.length) {
      return (
        <StudentTable
          type="highscore"
          data={sortedData()}
          isLoading={reportsLoading}
          sortClick={handleSortClick}
          sortDetail={sortDetail}
        />
      );
    }
    return <NoReport />;
  };
  return visible ? renderResult() : null;
};

export default HighScoreReportByStudent;
